export default __webpack_public_path__ + "static/media/default_avatar.585af9d3.jpg";